/**
 * Window/view access helpers.
 *
 * Prefer these over direct `window.*` / `globalThis.*` so cross-window concerns
 * (iframe/child window) stay localized and are easy to audit.
 */

export function getDefaultView(): Window | null {
    return document.defaultView || null;
}

export function getParentView(): Window | null {
    const view = getDefaultView();
    if (!view) return null;

    try {
        return view.parent || null;
    } catch (_error) {
        return null;
    }
}

export function getOpenerView(): Window | null {
    const view = getDefaultView();
    if (!view) return null;

    try {
        return view.opener || null;
    } catch (_error) {
        return null;
    }
}
